import { formatNameInitials } from '@libs/formatNames';
import { Avatar } from '@ui/components/Avatar';
import { AvatarSize } from '@ui/components/Avatar/Avatar';

type Props = {
  className?: string;
  user?: {
    firstName: string;
    lastName: string;
  };
  onClick?: () => void;
  size: AvatarSize;
};
export function UserAvatar({ className, size, user, onClick }: Props) {
  const initials = formatNameInitials(user) ?? '??';

  return <Avatar className={className} size={size} text={initials} onClick={onClick} />;
}
